import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LearningMapPage from './pages/LearningMapPage';
import QuestPage from './pages/QuestPage';
import QiqiaobanPage from './pages/QiqiaobanPage';
import TujiePage from './pages/TujiePage';
import QuickStartPage from './pages/QuickStartPage';
import GuanxinPage from './pages/GuanxinPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/map" element={<LearningMapPage />} />
        <Route path="/quest" element={<QuestPage />} />
        <Route path="/tujie" element={<TujiePage />} />
        <Route path="/qiqiaoban" element={<QiqiaobanPage />} />
        <Route path="/quick" element={<QuickStartPage />} />
        <Route path="/guanxin" element={<GuanxinPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
